module.exports = __webpack_public_path__ + "img/avatar.3d0e1547.svg";